import '../styles/variables.css';
import '../components/common.css';

import App from 'next/app';
import Head from 'next/head';
import React from 'react';
import { ApolloProvider } from "@apollo/client/react";
import {Router} from 'next/router';

import {withApolloClient} from '../lib/with-apollo-client';
import {UserProvider} from '../components/use-user';
import {RouterProvider} from '../lib/routes';
import {NotFoundSeo, SsrStatusProvider} from '../lib/seo';
import {Metrika} from '../components/metrika';
import {CookieBanner} from '../components/cookie-consent';

type State = {
	runtimeError?: Error;
};

class MyApp extends App<any> {
	state: State = {};

	static async getInitialProps(appContext: any) {
		return await App.getInitialProps(appContext);
	}

	componentDidMount(): void {
		// @ts-ignore
		const previousCallback = Router.onRouteChangeComplete;
		// @ts-ignore
		Router.onRouteChangeComplete = () => {
			// call previously defined callback if is a function
			if (typeof previousCallback === 'function') {
				previousCallback();
			}
		};
	}

	componentDidCatch(error: any) {
		if (this.state.runtimeError) {
			return;
		}
		this.setState({
			runtimeError: error,
		});
	}

	render() {
		const {runtimeError} = this.state;
		if (runtimeError) {
			return (
				<>
					<b>error</b>
					{JSON.stringify(runtimeError)}
				</>
			);
		}

		const {Component, pageProps, apolloClient, ssrStatus, ssrNotFound} = this.props;
		return (
			<SsrStatusProvider value={ssrStatus || null}>
				<ApolloProvider client={apolloClient}>
				<RouterProvider router={this.props.router}>
					<UserProvider>
						<Head>
							{/* с клавиатурой на Android уменьшается 100dvh, а не появляется прокрутка страницы */}
							<meta
								name="viewport"
								content="width=device-width, initial-scale=1, interactive-widget=resizes-content"
								key="viewport"
							/>
						</Head>
						<Component {...pageProps} />
						{/* 404, выясненный при серверном рендере: мета-теги «не найдено» поверх страницы */}
						{ssrNotFound && <NotFoundSeo />}
						<Metrika />
						<CookieBanner />
					</UserProvider>
				</RouterProvider>
				</ApolloProvider>
			</SsrStatusProvider>
		);
	}
}

export default withApolloClient(MyApp);
